<template>
  <v-container>
    <v-layout
      text-xs-center
      wrap
    >
      <v-flex xs12 sm10 md10 offset-sm1 offset-md1>
        <v-card :class="userElevation">
          <v-toolbar dark prominent color="primary">
            <v-toolbar-title class="title">
            Authorisation Config Admin
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn 
              v-if="!editMode"
              flat
              dark 
              outline
              @click="changeMode(true)">
                Edit
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-combobox
              v-model="formData.autoApproval"
              :readonly="!editMode"
              label="Email domains to auto approve"
              multiple
              small-chips
              deletable-chips
            ></v-combobox>
            
            <v-textarea
              v-model="formData.email"
              auto-grow
              rows=1
              :readonly="!editMode"
              label="Admin email address">
            </v-textarea>

            <v-switch 
              v-model="formData.informAdmin"
              color="primary"
              label="Inform Admin of Automatic Approval" 
              :readonly="!editMode">
            </v-switch>

            <v-textarea
              v-model="formData.appURL"
              auto-grow
              rows=1
              :readonly="!editMode"
              label="Application URL (for inclusion in emails)">
            </v-textarea>

          </v-card-text>
          <v-card-actions v-if="editMode">
            <v-btn 
              flat 
              color="secondary" 
              dark
              @click="saveChanges">Save</v-btn>
            <v-spacer></v-spacer>
            <v-btn 
              flat 
              color="blue darken-1" 
              dark
              @click="cancelChanges">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    data: () => ({
      formData: {},
      emailRules: [
              v => !!v || 'Email is required',
              v => /^(?:(?:[\w`~!#$%^&*\-=+;:{}'|,?\/]+(?:(?:\.(?:"(?:\\?[\w`~!#$%^&*\-=+;:{}'|,?\/\.()<>\[\] @]|\\"|\\\\)*"|[\w`~!#$%^&*\-=+;:{}'|,?\/]+))*\.[\w`~!#$%^&*\-=+;:{}'|,?\/]+)?)|(?:"(?:\\?[\w`~!#$%^&*\-=+;:{}'|,?\/\.()<>\[\] @]|\\"|\\\\)+"))@(?:[a-zA-Z\d\-]+(?:\.[a-zA-Z\d\-]+)*|\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])$/.test(v) || 'E-mail must be valid'
            ]
    }),
    created: function() {
      this.changeMode(false)
      this.loadDataIntoForm()
    },
    computed: {
      userElevation: function () {
        if (this.editMode == true) {
          return "elevation-24"
        } else {
          return "elevation-1"
        }
      },
      configData: function () {
        // get the latest version of the admin email configuration data from the store
        return this.$store.getters.getAdminEmail
      },
      editMode: function () {
        // get the current edit mode for the page from the store
        return this.$store.getters.getConfigEditMode
      }
    },
    watch: {
      editMode: function () {
        // when the edit mode changes refresh the visible data from the
        // current config data held in the store
        this.loadDataIntoForm()
      }
    },
    methods: {
      cancelChanges() {
        this.$forceUpdate();
        this.loadDataIntoForm()
        this.changeMode(false)
      },
      saveChanges() {
        this.$forceUpdate();
        //sort the role, specialty and topic Arrays
        this.formData.autoApproval.sort();
        //save the config data to firestore, and update the store, by dispatching an action
        this.$store.dispatch("saveAdminEmail",this.formData)
      },
      loadDataIntoForm() {
        //console.log("Config data",this.configData)
        //console.log("Form data before",this.formData)

        //clear out formData before reloading from configData
        this.formData = {}
        this.formData = Object.assign({},this.configData)

        //console.log("Form data after",this.formData)

        console.log("Form and config are the same - ",Object.is(this.configData,this.formData))
      },
      /* removeRole (item) {
        this.formData.roles.splice(this.formData.roles.indexOf(item), 1)
        //this.formData.roles = [...this.formData.roles]
      }, */
      changeMode (toggle) {
        // toggle the form in and out of edit mode using an mutation in the store
        this.$store.commit('setConfigEditMode',toggle)
      }
    }
  }
</script>

<style>

</style>
